import $ from 'jquery';
import { getState } from '~src/state';
import { loadSelectTags } from '~src/sidebar/index';
import { isLoggedUserGlobalEditor } from '~src/user';
import { EdgeResizer, checkUserOwnership } from '~src/utils';

export const displayImageManager = async (imageItemId) => {
  const currentTag = getState('sidebarCurrentImagesTag', 'NO_TAG');

  const imageItem = window.editorConfig.sidebarImages[currentTag].items.find(
    (item) => item.objectId === imageItemId
  );
  const isUserOwner = await checkUserOwnership(imageItem);
  const isGlobalEditor = await isLoggedUserGlobalEditor();

  if (!$(`#tag-preview-image-${imageItem.objectId}`).length) {
    const previewImg = new EdgeResizer(imageItem.file.url).scaleToWidth(200);

    let descriptionHtml = `<div
      id="tag-preview-image-${imageItem.objectId}"
      class="items-tag-image-container">
        <img
            src="../assets/svg/img-loader.gif"
            class="lazy items-tag-image"
            data-src="${previewImg}"
        />
        </div>
        `;
    if (imageItem.width) {
      descriptionHtml += `
        <div class="tag-preview-background-container-description">
          <div class="tag-preview-background-container-description-title">
            Dimensioni:
          </div>
          <div class="tag-preview-background-container-description-text">
            Altezza: ${imageItem.height} px - Larghezza: ${imageItem.width} px
          </div>
        </div>`;
    }

    $('#tag-image-container').html(descriptionHtml);
    window.lazyLoadInstance.update();
  }
  let tagsHtml = '';
  imageItem.tags.forEach(function (item) {
    tagsHtml += `
    <a
                id="btn-menu-frames"
                class="btn px-3 buttonBoxIcon"
                nohref
                role="button"
              >
                #${item.name}`;
    if (isUserOwner || isGlobalEditor) {
      tagsHtml += `
                <div
                  id="delete-tag-${item.objectId}"
                  data-delete-image-id="${imageItem.objectId}"
                  data-delete-tag-id="${item.objectId}"
                  data-delete-tag-user-owner="${isUserOwner}"
                  class="buttonSvg editor-tag-delete"
                >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
            </svg>
              </div>
                <div
                    id="editor-btn-spinner-${item.objectId}"
                    class="spinner-grow spinner-grow-sm text-light"
                    role="status"
                    style="display: none;"
                  >
                </div>`;
    }
    tagsHtml += '</a>';
  });
  $('#tag-container').html(tagsHtml);

  if (isGlobalEditor || isUserOwner) {
    let selectTagsHtml = `
    <div  id="tag-select">
    <select id="tagImageSelect" multiple="multiple"> </select>
    </div>
    <button class="buttonSidebarSaveTags" data-save-tag-image-id="${imageItem.objectId}" id="saveNewTags">
    Salva
        <div
          id="editor-btn-spinner"
          class="spinner-grow spinner-grow-sm text-light"
          role="status"
          style="display: none;"
        >
        </div>
    </button>`;
    $('#selectTag-container').html(selectTagsHtml);
    loadSelectTags(imageItemId);
  } else {
    $('#selectTag-container').empty();
  }
};
